import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Idiomas soportados
const supportedLanguages = ['en', 'es', 'fr', 'de', 'it', 'pt', 'ru', 'zh', 'ja', 'ko', 'ar', 'hi', 'tr', 'nl', 'sv', 'pl', 'vi', 'th', 'id', 'sw', 'ca'];

// Función para normalizar el código de idioma
const normalizeLanguage = (lng) => {
  // Obtener el código base (por ejemplo, 'en' de 'en-US')
  const baseLng = lng.split('-')[0].toLowerCase();
  
  // Comprobar si el idioma base está soportado
  if (supportedLanguages.includes(baseLng)) {
    return baseLng;
  }
  
  // Si no está soportado, devolver inglés
  return 'en';
};

i18n
  // Carga traducciones usando http
  .use(Backend)
  // Detecta el idioma del usuario
  .use(LanguageDetector)
  // Pasa el i18n a react-i18next
  .use(initReactI18next)
  // Inicializa i18next
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // no es necesario para React
    },
    
    // Configuración de detección de idioma
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'userLanguage',
      caches: ['localStorage'],
      checkWhitelist: true,
    },
    
    // Opciones de backend para cargar archivos de traducción
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Normalizar el idioma detectado
    load: 'languageOnly',
    
    // Whitelist de idiomas soportados
    supportedLngs: supportedLanguages,
    
    // Función para normalizar el idioma
    lowerCaseLng: true,
    
    react: {
      useSuspense: false,
    }
  });

// Evento cuando cambia el idioma
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  // También puedes ajustar la dirección del texto para idiomas RTL como árabe
  document.documentElement.dir = ['ar', 'he', 'fa'].includes(lng) ? 'rtl' : 'ltr';
});

// Exportar la función de normalización para usarla en otros lugares
export const normalizeLanguageCode = normalizeLanguage;

export default i18n;